import React from 'react';

export function Skeleton({ className = '' }) {
  return (
    <div className={`relative overflow-hidden rounded-md bg-[#141416] ${className}`}>
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/[0.04] to-transparent" />
    </div>
  );
}

export function SkeletonText({ lines = 1, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {[...Array(lines)].map((_, i) => (
        <Skeleton key={i} className={`h-4 ${i === lines - 1 && lines > 1 ? 'w-3/4' : 'w-full'}`} />
      ))}
    </div>
  );
}

export function SkeletonCard({ className = '' }) {
  return (
    <div className={`bg-[#0f0f11] border border-white/[0.04] rounded-xl p-6 ${className}`}>
      <div className="flex items-start justify-between mb-6">
        <div className="space-y-2"><Skeleton className="h-5 w-32" /><Skeleton className="h-3 w-24" /></div>
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>
      <Skeleton className="h-20 w-full rounded-lg mb-6" />
      <div className="flex justify-between"><Skeleton className="h-3 w-24" /><Skeleton className="h-3 w-28" /></div>
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 4 }) {
  return (
    <div className="space-y-3">
      <div className="flex gap-4 px-4 py-3 border-b border-white/[0.04]">
        {[...Array(cols)].map((_, i) => <Skeleton key={i} className="h-3 flex-1" />)}
      </div>
      {[...Array(rows)].map((_, r) => (
        <div key={r} className="flex gap-4 px-4 py-4">
          {[...Array(cols)].map((_, c) => <Skeleton key={c} className="h-4 flex-1" />)}
        </div>
      ))}
    </div>
  );
}

export default Skeleton;
